import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "gift"
const GiftIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M5.974 2.598C7.438 1.134 9.812 1.134 11.276 2.598 11.883 3.205 12.173 4.278 12.308 5.381 12.422 4.964 12.585 4.59 12.815 4.314L12.915 4.204C14.03 3.088 15.838 3.088 16.953 4.204L17.055 4.31C17.863 5.204 17.99 6.474 17.46 7.5H20.25C21.078 7.5 21.75 8.172 21.75 9V12.75C21.75 13.31 21.441 13.797 20.985 14.055Q21 14.15 21 14.25V21C21 21.777 20.41 22.416 19.653 22.492L19.5 22.5H4.5L4.347 22.492C3.64 22.421 3.08 21.86 3.008 21.153L3 21V14.25Q3.001 14.151 3.014 14.056C2.6 13.823 2.308 13.4 2.258 12.903L2.25 12.75V9C2.25 8.172 2.922 7.5 3.75 7.5H5.672C4.542 6.034 4.628 3.943 5.974 2.598M4.5 21H11.25V14.25H4.5zM12.75 21H19.5V14.25H12.75zM3.75 12.75H11.25V9.03C10.793 9.038 10.247 9.035 9.675 9H3.75zM14.94 9C14.15 9.112 13.326 9.111 12.75 9.097V12.75H20.25V9zM10.216 3.66C9.337 2.78 7.913 2.78 7.034 3.659 6.17 4.523 6.168 5.922 7.061 6.815 7.17 6.925 7.429 7.085 7.92 7.226 8.396 7.362 8.966 7.446 9.568 7.491L9.717 7.5H10.916C10.92 7.101 10.912 6.653 10.88 6.17 10.837 5.563 10.756 4.99 10.622 4.515 10.483 4.022 10.323 3.766 10.216 3.66M15.893 5.264C15.363 4.734 14.505 4.734 13.975 5.264 13.955 5.284 13.855 5.414 13.758 5.762 13.665 6.09 13.606 6.5 13.575 6.948Q13.555 7.239 13.55 7.5H14.83Q15.126 7.454 15.37 7.384C15.718 7.284 15.85 7.184 15.872 7.16 16.416 6.618 16.408 5.78 15.892 5.264"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default GiftIcon
